import { type ApolloClient, type NormalizedCacheObject, gql } from '@apollo/client/core';
import type { Query, QueryWebhookDeliveryAttemptsArgs } from '../../../generated/api.graphql';
import { CONNECTION_METADATA_FIELDS } from '../../connection/Api';
import * as GqlConnection from '../../connection/GqlConnection';
import * as WebhookDeliveryAttempt from './WebhookDeliveryAttempt';
import type { WebhookDeliveryAttemptSearchArguments } from './WebhookDeliveryAttemptSearchArguments';
import { WEBHOOK_DELIVERY_ATTEMPT_FIELDS } from './fragments';

export const PAGE_SIZE = 50;

export const WEBHOOK_DELIVERY_ATTEMPTS_QUERY = gql`
  query WebhookDeliveryAttempts(
    $subscriptionId: ID!, $first: Int, $after: String, $topic: String, $attemptedAfter: ISO8601DateTime, $attemptedBefore: ISO8601DateTime
  ) {
    webhookDeliveryAttempts(
      subscriptionId: $subscriptionId, first: $first, after: $after, topic: $topic, attemptedAfter: $attemptedAfter, attemptedBefore: $attemptedBefore
    ) {
      edges {
        cursor
        node {
          ...WebhookDeliveryAttemptFields
        }
      }
      pageInfo {
        ...ConnectionMetadataFields
      }
    }
  }
  ${WEBHOOK_DELIVERY_ATTEMPT_FIELDS}
  ${CONNECTION_METADATA_FIELDS}
`;

export const fetchWebhookDeliveryAttempts = async (
  client: ApolloClient<NormalizedCacheObject>,
  subscriptionId: number,
  filter: WebhookDeliveryAttemptSearchArguments,
  after?: string,
): Promise<GqlConnection.GqlConnection<WebhookDeliveryAttempt.WebhookDeliveryAttempt>> => {
  const variables: QueryWebhookDeliveryAttemptsArgs = { subscriptionId: String(subscriptionId), first: PAGE_SIZE };

  if (after) {
    variables.after = after;
  }
  if (filter.topic) {
    variables.topic = filter.topic;
  }
  if (filter.attemptedAfter) {
    variables.attemptedAfter = filter.attemptedAfter;
  }
  if (filter.attemptedBefore) {
    variables.attemptedBefore = filter.attemptedBefore;
  }

  const { data } = await client.query<Pick<Query, 'webhookDeliveryAttempts'>>({
    query: WEBHOOK_DELIVERY_ATTEMPTS_QUERY,
    fetchPolicy: 'network-only',
    variables,
  });

  return WebhookDeliveryAttempt.fromGqlConnection(data.webhookDeliveryAttempts);
};
